export const customAccordionStyles = {
  button: {
    p: {
      mb: 0,
      fontSize: "lg",
      textAlign: "left",
      fontWeight: "bold",
    },
  },
  ".chakra-accordion__item": {
    background: "transparent",
  },
  ".chakra-accordion__panel": {
    px: 0,
  },
};
